export const authorizeVacationListColumns = [
  { field: 'user', headerName: 'Consultor', lookUp: 'user.name' },
  { field: 'startDate', headerName: 'Desde' },
  { field: 'endDate', headerName: 'Hasta' },
  { field: 'days', headerName: 'Duración' },
  { field: 'actions', headerName: 'Acciones' },
];
